// src/store.js
import { createStore, applyMiddleware, compose } from "redux";
import reduxThunk from "redux-thunk";
import reducers from "../reducers/index";

// Enable Redux DevTools only in development
const composeEnhancers =
  process.env.NODE_ENV === "development" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

// Create store with middleware + DevTools
const store = createStore(reducers, composeEnhancers(applyMiddleware(reduxThunk)));

export default store;
